import storage from 'utils/storage'

const RUNTIME_ENV_KEY = 'runtime-env'
const ENV_TEST = 'test'
const ENV_PRODUCTION = 'production'
// 非生产构建（preview 部署及本地 development）允许在登录页切换环境
const SWITCHABLE_BUILD_ENVS = ['preview']
// 可在运行时切换的环境
const RUNTIME_ENVS = [ENV_TEST, ENV_PRODUCTION]
// 非生产构建默认使用测试环境
const DEFAULT_RUNTIME_ENV = ENV_TEST

const buildEnv = process.env.BUILD_ENV
// 本地 npm run dev 调试时 mode 为 development
const isDev = process.env.NODE_ENV === 'development'

export function isEnvSwitchable() {
  return isDev || SWITCHABLE_BUILD_ENVS.includes(buildEnv)
}

export function getBuildEnv() {
  return buildEnv
}

/**
 * 当前生效的环境。
 * 生产构建固定为线上环境；preview 部署与本地开发默认测试环境，
 * 可在登录页切换到线上环境。切换结果存入 localStorage，
 * 刷新页面后各模块初始化时读取生效。
 */
export default function getEnv() {
  if (!isEnvSwitchable()) return buildEnv
  const savedEnv = storage.get(RUNTIME_ENV_KEY)
  return RUNTIME_ENVS.includes(savedEnv) ? savedEnv : DEFAULT_RUNTIME_ENV
}

export function setEnv(env) {
  if (!isEnvSwitchable() || !RUNTIME_ENVS.includes(env)) return
  storage.set(RUNTIME_ENV_KEY, env)
}
